import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../components/bannerfrom";
import { Link } from "gatsby";

function Banner(props) {
  return (
    <div className="services_location_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Austin">
                <h1>Full-Scale Mobile App Development in Austin</h1>
              </div>
              <p className="main_para">
                Build stellar user-facing platforms that are accessible, fast,
                and interactive. From engagement-driven interfaces and
                performant business functionalities to adaptive frameworks and
                secure data management, TekRevol helps you conceptualize,
                design, and launch compatible-for-all apps using novel
                technologies and proficient resources – making us your ideal{" "}
                <Link to="/app-development-austin">
                  mobile app development company in Austin.
                </Link>
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Explore Custom App Development
              </Link>
              <Link
                to="/app-cost-calculator"
                className="border_btn dark_btn mx-xl-3 mx-md-0"
                aria-label="TekRevol Contact"
              >
                Calculate Your App Cost
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
